<template>
    <div class="full-container" :class="mobile ? 'mobile' : 'desktop'">
        <div class="over d-flex flex-wrap align-items-start align-content-start">
            <div class="w-100 d-flex flex-xl-wrap justify-content-start align-items-stretch align-content-stretch px-3 px-sm-4 px-xl-5 py-4 headerSpace mb-0">
                <img :src="logo" class="pe-none resizeHeight">
                <div class="flex-fill font-1-1 t-28 t-sm-23 t-xl-20 t-xxl-14 label-1 text-start ps-3 ps-xl-5 align-items-center align-content-center d-flex">
                    <span class="ps-sm-2 p-md-4">Información de Transacción</span>
                </div>
            </div>
            <div class="w-100 justify-content-center d-flex flex-wrap mb-5">
                <div class="col-11 col-sm-8 col-xl-9 col-xxl-7 algin-items-start align-content-start justify-content-start d-flex flex-wrap mt-5 px-3 font-2-1">
                    <div class="w-100 label-1-1 fw-bold text-start t-18 t-sm-6 t-md-12 t-xl-9 t-xxl-6">Detalles de la Gift Card</div>
                    <div class="cont ps-3 w-100 text-start t-xxl-4 t-12 t-sm-5 t-md-5 t-lg-12 t-xl-8">
                        <span class="fw-bold">Fecha de envío programado:</span> {{formData(formFields.step3.receiverDate.date)}}
                    </div>
                    <div class="cont ps-3 w-100 text-start t-xxl-4 t-12 t-sm-5 t-md-5 t-lg-12 t-xl-8">
                        <span class="fw-bold">Monto:</span> ${{formFields.step1.amount.value}} MXN
                    </div>
                    <div class="cont ps-3 w-100 text-start t-xxl-4 t-12 t-sm-5 t-md-5 t-lg-12 t-xl-8">
                        <span class="fw-bold">Destinatario:</span> +52 {{formFields.step2.receiverWhatsapp}} / {{capitalizeWords(formFields.step1.receiverName)}}
                    </div>


                    <template v-if="formFields.step4.payForm != 'online'">

                        <div class="w-100 label-1-1 fw-bold text-start t-18 t-sm-6 t-md-12 t-xl-9 t-xxl-6 mt-4">Instrucciones para completar tu compra</div>
                        <div class="cont ps-3 w-100 text-start t-xxl-4 t-12 t-sm-5 t-md-5 t-lg-12 t-xl-8">
                            <span class="fw-bold">1.</span> Visita la sucursal Boston’s {{this.cities[formFields.step7.cityIndex].stores[formFields.step7.storeId].name}}
                        </div>
                        <div class="cont ps-3 w-100 text-start t-xxl-4 t-12 t-sm-5 t-md-5 t-lg-12 t-xl-8">
                            <span class="fw-bold">2.</span> Presenta el código QR que recibirás en el número +52 {{formFields.step4.senderWhatsapp}}
                        </div>
                        <div class="cont ps-3 w-100 text-start t-xxl-4 t-12 t-sm-5 t-md-5 t-lg-12 t-xl-8">
                            <span class="fw-bold">3.</span> Realiza el pago en efectivo o utilizando tu tarjeta de crédito / débito
                        </div>
                        <div class="cont ps-3 w-100 text-start t-xxl-4 t-12 t-sm-5 t-md-5 t-lg-12 t-xl-8">
                            <span class="fw-bold">4.</span> Una vez completado el pago, tu gift card será activada y enviada según la fecha programada.
                        </div>

                        <div class="w-100 label-1-1 fw-bold text-start t-18 t-sm-6 t-md-12 t-xl-9 t-xxl-6 mt-4">Nota:</div>
                        <div class="cont ps-3 w-100 text-start t-xxl-4 t-12 t-sm-5 t-md-5 t-lg-12 t-xl-8">
                            Por favor, asegúrate de seguir estos pasos para garantizar que tu compra se procese correctamente.
                        </div>

                    </template>

                    <div class="w-100 justify-content-center mt-5">
                        <button class="buttonBuyAgain t-16 t-sm-10 t-md-9 t-xl-10 t-xxl-4 font-2-1 fw-bold" role="button" @click="buyAgain()">Finalizar</button>
                    </div>

                    
                </div>
            </div>
        </div>
        <div class="diamond" ref="gift" @click="applyNewAnimation()">

            <div class="giftCard" ref="card" @click="hide()">
                <design-list :formFields="formFields" :fit="false" :static="true"></design-list>
            </div>
            <div class="triangle top" ref="ttop">
                <svg viewBox="0 0 100 50">
                    <polygon points="50,0 0,50 100,50" />
                </svg>
            </div>
            <div class="triangle right" ref="tright">
                <svg viewBox="0 0 50 100">
                    <polygon points="50,50 0,0 0,100" />
                </svg>
            </div>
            <div class="triangle bottom" ref="tbottom">
                <svg viewBox="0 0 100 50">
                    <polygon points="50,50 0,0 100,0" />
                </svg>
            </div>
            <div class="triangle left" ref="tleft">
                <svg viewBox="0 0 50 100">
                    <polygon points="0,50 50,0 50,100" />
                </svg>
            </div>
            <div class="ribbon" ref="ribbon">
                <svg height="100%" width="100%" version="1.1" id="_x34_" xmlns="http://www.w3.org/2000/svg"
                    xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 512 512" xml:space="preserve">
                    <g>
                        <path style="fill:#E83D3A;" d="M121.342,376.011c-0.563,1.033-1.665,1.665-2.848,1.619c-1.174-0.053-2.227-0.751-2.711-1.822
                        l-24.414-54.336c-0.582-1.283-1.934-2.013-3.319-1.796l-58.832,9.355c-1.164,0.178-2.336-0.309-3.016-1.276
                        c-0.688-0.961-0.76-2.23-0.197-3.27L169.165,59.564c0.815-1.5,2.704-2.066,4.204-1.256l89.882,48.579
                        c1.5,0.809,2.066,2.691,1.256,4.204L121.342,376.011z" />
                        <path style="fill:#BD2221;" d="M263.25,106.886l-89.882-48.579c-1.5-0.81-3.389-0.244-4.204,1.256L64.99,252.557l79.97,79.968
                        L264.507,111.09C265.316,109.577,264.75,107.696,263.25,106.886z" />
                        <path style="fill:#BD2221;" d="M376.513,376.011c0.552,1.033,1.651,1.665,2.836,1.619c1.178-0.053,2.23-0.751,2.724-1.822
                        l24.414-54.336c0.566-1.283,1.927-2.013,3.309-1.796l58.836,9.355c1.165,0.178,2.336-0.309,3.019-1.276
                        c0.685-0.961,0.757-2.23,0.191-3.27L328.69,59.564c-0.816-1.5-2.703-2.066-4.21-1.256l-89.882,48.579
                        c-1.506,0.809-2.065,2.691-1.256,4.204L376.513,376.011z" />
                        <path style="fill:#E83D3A;" d="M0,172.689c0,28.052,22.562,34.743,43.543,28.796c16.852-4.783,185.51-53.559,185.51-53.559V55.558
                        c0,0-168.658-48.783-185.51-53.559C22.562-3.949,0,2.735,0,30.788V172.689z" />
                        <path style="fill:#CE271C;" d="M188.632,153.498c0,1.605,2.684,3.165,3.131,4.619c20.605-6.013,37.29-10.191,37.29-10.191V55.558
                        c0,0-13.474-4.264-40.421-10.402V153.498z" />
                        <path style="fill:#E83D3A;" d="M512,172.689c0,28.052-19.191,34.743-40.171,28.796c-16.849-4.783-182.145-53.559-182.145-53.559
                        V55.558c0,0,165.296-48.783,182.145-53.559C492.809-3.949,512,2.735,512,30.788V172.689z" />
                        <g>
                            <path style="fill:#CE271C;" d="M289.684,55.558v92.368c0,0,98.697,29.421,151.526,44.803L301.309,51.873
                            C293.428,54.183,289.684,55.558,289.684,55.558z" />
                        </g>
                        <path style="fill:#E83D3A;" d="M296.421,149.32c0,7.566-0.888,15.586-8.44,15.586h-71.132c-7.566,0-14.743-8.02-14.743-15.586
                        V53.577c0-7.572,7.177-9.934,14.743-9.934h71.132c7.553,0,8.44,2.362,8.44,9.934V149.32z" />
                    </g>
                </svg>
            </div>
        </div>
    </div>
</template>

<script>
import designList from '@/components/designList.vue'
export default {
    name: 'GiftCard',
    emits:['reset'],
    props: {
        formFields: {},
        cities:[],
        logo:''
    },
    components: {
        designList
    },
    methods:{
        buyAgain(){
            this.$emit('reset');
        },
        formData2(string){
            switch (string) {
                case 'cash':
                    return 'Efectivo';
                case 'card':
                    return 'Tarjeta de crédito/débito';
                default:
                    return 'Efectivo';
            }
        },
        formData(dateT){
            let date = new Date(dateT);
            console.log(date);
            return date.toLocaleDateString('es-ES', {
                weekday: 'long',
                day: 'numeric',
                month: 'long',
                year: 'numeric',
            });
        },
        hide(){
            const infoSpace = this.$refs.infoSpace;
            const gift = this.$refs.gift;
            gift.style.display = "none";
            if(this.mobile){
                infoSpace.style.bottom = "20vh";
            }else{
                infoSpace.style.right = "30vw";
            }
        },
        applyNewAnimation() {
            const card = this.$refs.card;
            const gift = this.$refs.gift;
            const ribbon = this.$refs.ribbon;
            const ttop = this.$refs.ttop;
            const tbottom = this.$refs.tbottom;
            const tleft = this.$refs.tleft;
            const tright = this.$refs.tright;


            ribbon.style.display = "none"; 
            ttop.style.animation = "none"; 
            ttop.offsetHeight; 
            tbottom.style.animation = "none"; 
            tbottom.offsetHeight; 
            tleft.style.animation = "none"; 
            tleft.offsetHeight; 
            tright.style.animation = "none"; 
            tright.offsetHeight; 
            
            gift.style.zIndex = "1000";
            
            card.style.opacity = "1"; 
            card.style.animation = "none"; 
            card.offsetHeight; 
            card.style.zIndex = "1000";

            if(this.mobile){
                gift.style.animation = "none"; 
                gift.offsetHeight;
                gift.style.transform = "translateX(0px) translateY(0px)";
                card.style.transform = "rotateZ(0deg) scale(7.5) translate(-6%, -11%)";
            }else{
                card.style.transform = "rotateZ(15deg) scale(3) translate(-15%, -15%)";
            }
        }
    },
    data() {
        return {
            mobile: window.innerWidth < 1200
        }
    },
}
</script>

<style scoped>
/* Contenedor que ocupa toda la ventana */
.full-container {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100vw;
    height: 100vh;
    background-color: #444;
    perspective: 800px;
    overflow: hidden;
}

.over {
    height: 100%;
    width: 100%;
    position: fixed;
    left: 0;
    top: 0;
    /*opacity: 0.1;
    background: #fff;
    background-repeat: repeat;
    background-size: 80px 80px;*/
    background-color:#fff
    /* Tamaño del elemento repetido */
}

/* Cuadrado central */
.diamond {
    display:none;
    position: relative;
    width: 100px;
    height: 100px;
    background-color: #007bff;
    transform-style: preserve-3d;
    z-index: 2;
}

.mobile .diamond {
    transform: translateY(100vh) scale(2.5);
    animation: escene1 3.8s 1 linear forwards;
}

.desktop .diamond {
    transform: translateX(100vw) scale(2.5);
    animation: escene2 3.8s 1 linear forwards;
}

/* Tarjeta de regalo dentro del diamond */
.giftCard {
    position: absolute;
    z-index: 2;
    /* Debajo de los triángulos */
    height: 87px;
    width: 48px;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%) rotateZ(-15deg) scale(5);
    opacity: 0;
    animation: append 1s linear 1 forwards;
    animation-delay: 0.7s;
    z-index: 10000;
}

.ribbon {
    position: absolute;
    left: 12.5%;
    top: 12.5%;
    height: 75%;
    width: 75%;
    opacity: 0;
    transform: scale(4) translateZ(100px);
    animation: append2 0.5s linear 1 forwards;
    animation-delay: 2.8s;
    display: flex;
    align-items: center;
    align-content: center;
    justify-content: center;
    z-index: 200;
}

.ribbon svg {
    margin-top: 45%;
    z-index: 200;
}

/* Triángulos */
.triangle {
    position: absolute;
    z-index: 3;
    /* Encima de la tarjeta */
    transform-origin: 50% 100%;
    transform-style: preserve-3d;
}

.triangle.top {
    top: -50px;
    left: 0;
    width: 100px;
    height: 50px;
    animation: foldTop 1s 1s forwards;
    animation-delay: 2s;
}

.triangle.right {
    top: 0;
    left: 100px;
    width: 50px;
    height: 100px;
    transform-origin: 0% 50%;
    animation: foldRight 1s 1s forwards;
    animation-delay: 2.1s;
}

.triangle.bottom {
    bottom: -50px;
    left: 0;
    width: 100px;
    height: 50px;
    transform-origin: 50% 0%;
    animation: foldBottom 1s 1s forwards;
    animation-delay: 2.2s;
}

.triangle.left {
    top: 0;
    right: 100px;
    width: 50px;
    height: 100px;
    transform-origin: 100% 50%;
    animation: foldLeft 1s 1s forwards;
    animation-delay: 2.3s;
}

/* Polígonos */
polygon {
    fill: blue;
}

.triangle.top polygon {
    fill: #0056b3;
}

.triangle.right polygon {
    fill: #0073e6;
}

.triangle.bottom polygon {
    fill: #3399ff;
}

.triangle.left polygon {
    fill: #66ccff;
}

/* Animaciones */
@keyframes foldTop {
    0% {
        transform: rotateX(0deg);
    }

    100% {
        transform: rotateX(-180deg);
    }
}

@keyframes foldRight {
    0% {
        transform: rotateY(0deg);
    }

    100% {
        transform: rotateY(-180deg);
    }
}

@keyframes foldBottom {
    0% {
        transform: rotateX(0deg);
    }

    100% {
        transform: rotateX(180deg);
    }
}

@keyframes foldLeft {
    0% {
        transform: rotateY(0deg);
    }

    100% {
        transform: rotateY(180deg);
    }
}

@keyframes foldTopInverted {
    0% {
        transform: rotateX(-180deg);
    }
    100% {
        transform: rotateX(0deg);
    }

    
}

@keyframes foldRightInverted {
    0% {
        transform: rotateY(-180deg);
    }
    100% {
        transform: rotateY(0deg);
    }

    
}

@keyframes foldBottomInverted {
    0% {
        transform: rotateX(180deg);
    }
    100% {
        transform: rotateX(0deg);
    }

    
}

@keyframes foldLeftInverted {
    0% {
        transform: rotateY(180deg);
    }
    100% {
        transform: rotateY(0deg);
    }

    
}

@keyframes escene1 {
    0% {
        transform: translateY(100vh) translateX(-25vw) scale(1.5) rotateZ(75deg);
    }

    20% {
        transform: translateY(0vh) translateX(0vw) scale(1.5) rotateZ(-15deg);
    }

    90% {
        transform: translateY(0vh) translateX(0vw) scale(1.5) rotateZ(-15deg);
    }

    100% {
        transform: translateY(-35vh) translateX(0vw) scale(1.5) rotateZ(-15deg);
    }
}

@keyframes escene2 {
    0% {
        transform: translateX(100vw) translateY(-25vh) scale(2.5) rotateZ(75deg);
    }

    20% {
        transform: translateX(0) translateY(0vh) scale(2.5) rotateZ(-15deg);
    }

    90% {
        transform: translateX(0) translateY(0vh) scale(2.5) rotateZ(-15deg);
    }

    100% {
        transform: translateX(-25vw) translateY(0vh) scale(2.5) rotateZ(-15deg);
    }
}

@keyframes append2 {
    0% {
        opacity: 0;
        transform: scale(4) translateZ(100px);
    }

    100% {
        opacity: 1;
        transform: scale(1) translateZ(0px);
    }
}

@keyframes append {
    0% {
        opacity: 0;
        transform: rotateZ(0deg) scale(5);
        z-index: 50;
    }

    50% {
        opacity: 0;
    }

    100% {
        opacity: 1;
        z-index: 2;
        transform: translate(-50%, -50%) rotateZ(-15deg) scale(1);
    }
}

@keyframes appendRapid {
    0% {
        opacity: 0;
    }

    100% {
        opacity: 1;
    }
}

.mobile .infoSpace {
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    align-items: center;
    align-content: center;
    width: 90vw;
    height: 45vh;
    right: 5vw;
    background-color: transparent;
    position: absolute;
    bottom: 12vh;
    z-index: 100;
    opacity: 0;
    animation: appendRapid 1s 1s forwards;
    animation-delay: 3.5s;
}

.desktop .infoSpace {
    width: 40vw;
    height: 80vh;
    right: 10vw;
    background-color: transparent;
    position: absolute;
    top: 10vh;
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    align-items: center;
    align-content: center;
    opacity: 0;
    animation: appendRapid 1s 1s forwards;
    animation-delay: 3.5s;
}

.infoSpace .card {
    width: 100%;
    background-color: #fff;
    border-radius: 10px;
    box-shadow: 0px 4px 6px rgba(0, 0, 0, 0.1);
    padding: 20px;
    color: var(--primary);
    text-align: left;
    display: flex;
    flex-direction: column;
    gap: 10px;
}

.infoSpace .card-title {
    font-weight: bold;
    color: var(--secondary);
}

.infoSpace .contact-info {
    display: flex;
    align-items: flex-start;
    gap: 10px;
}

.infoSpace .whatsapp-icon {
    width: 40px;
    height: 40px;
    border-radius: 50%;
    object-fit: contain;
}

.infoSpace p {
    margin: 0 0;
    line-height: 1;
}

/* Círculo del teléfono */
.phone-circle {
    background-color: transparent;
    border: 2px solid var(--primary);
    width: 150px;
    height: 150px;
    border-radius: 50%;
    display: flex;
    justify-content: center;
    align-items: center;
    box-shadow: 0px 4px 6px rgba(0, 0, 0, 0.1);
    margin-bottom: 5%;
}
.mobile .phone-circle{
    transform: scale(0.5);
    transform-origin: 50% 100%;
}

/* Teléfono */
.phone {
    background-color: #000;
    width: 70px;
    height: 120px;
    border-radius: 15px;
    display: flex;
    justify-content: center;
    align-items: center;
}

/* Pantalla del Teléfono */
.screen {
    background-color: #111;
    width: 60px;
    height: 110px;
    border-radius: 10px;
}
.buttonBuyAgain {
    width: auto;
    align-items: center;
    background: var(--secondary);
    border: 0 solid #E2E8F0;
    box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06);
    box-sizing: border-box;
    color: var(--tertiaryText);
    display: inline-flex;
    height: 56px;
    justify-content: center;
    line-height: 24px;
    overflow-wrap: break-word;
    padding: 24px;
    text-decoration: none;
    margin-top: 2%;
    border-radius: 18px;
    cursor: pointer;
    user-select: none;
    -webkit-user-select: none;
    touch-action: manipulation;
  }

  @keyframes fadeOut {
    0% {
        opacity: 1;
    }

    100% {
        opacity: 0;
    }
    
  }

  .resizeHeight{
    height: 100%;
    max-height: 50px;
    object-fit: contain;
}
.headerSpace{
    min-height: 100px;
    max-height: 100px;
}

.label-1{
    line-height: 1;
    font-weight: 500;
    color:var(--secondaryText)
}
.label-1-1{
    line-height: 2;
    color:var(--primaryText)
}
@media (min-width: 768px) {
    .headerSpace{
        min-height: 180px;
        max-height: 180px;
    }
    .resizeHeight{
        max-height: 120px;
    }
}

.cont {
    color:var(--primaryText);
    display: inline; /* Asegura que todo el contenido fluya dentro del mismo contenedor */
    white-space: normal; /* Permite que el texto se ajuste a múltiples líneas */
    word-break: break-word; /* Divide palabras largas si es necesario */
    overflow-wrap: break-word; /* Asegura el ajuste correcto del texto */
}
  
  

</style>